import { FC } from 'react';
import { useAppSelector } from '../../../hooks';
import { authSelector } from '../../../store/slices';

export const TopBar: FC = () => {
  const { user } = useAppSelector(authSelector);

  return (
    <div className="bg-white flex py-4 justify-around items-center">
      <div className="relative w-8/12 lg:w-5/12" />
      <div className="flex items-center space-x-2">
        <div className="rounded-full h-9 w-9 relative bg-dark-blue">
          <p className="absolute flex items-center justify-center bold h-full w-full text-white">
            {user?.firstName?.charAt(0)}
            {user?.lastName?.charAt(0)}
          </p>
        </div>
        <p className="hidden lg:block">
          {user?.firstName} {user?.lastName}
        </p>
      </div>
    </div>
  );
};
